import { Overlay, OverlayContainer, OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalActionsDirective } from './modal-actions.directive';
import { ModalBottomContainerComponent } from './modal-bottom-container.component';
import { ModalCloseDirective } from './modal-close.directive';
import { ModalContainerComponent } from './modal-container.component';
import { ModalContentDirective } from './modal-content.directive';
import { ModalCustomContainerComponent } from './modal-custom-container.component';
import { ModalOverlay } from './modal-overlay';
import { ModalOverlayContainer } from './modal-overlay-container';
import { ModalRightContainerComponent } from './modal-right-container.component';
import { ModalTitleDirective } from './modal-title.directive';
import { ModalTopContainerComponent } from './modal-top-container.component';
import { MODAL_SCROLL_STRATEGY_PROVIDER, ModalService } from './modal.service';

@NgModule({
    imports: [
        CommonModule,
        OverlayModule,
        PortalModule,
        ModalTitleDirective,
        ModalActionsDirective,
        ModalCloseDirective,
        ModalContentDirective,
        ModalCustomContainerComponent,
        ModalBottomContainerComponent,
        ModalRightContainerComponent,
        ModalTopContainerComponent,
        ModalContainerComponent
    ],
    exports: [
        ModalContainerComponent,
        ModalTopContainerComponent,
        ModalRightContainerComponent,
        ModalBottomContainerComponent,
        ModalCustomContainerComponent,
        ModalCloseDirective,
        ModalTitleDirective,
        ModalActionsDirective,
        ModalContentDirective
    ],
    providers: [
        ModalService,
        MODAL_SCROLL_STRATEGY_PROVIDER,
        {
            provide: Overlay,
            useExisting: ModalOverlay
        },
        {
            provide: OverlayContainer,
            useExisting: ModalOverlayContainer
        }
    ]
})
export class ModalModule {}
